import { DEFAULT_LOCATION } from '../constants/defaultLocation';
import api from './api';

const getProvince = () => {
  return api.get('parameter/v1/province');
};

const getCity = (isocode) => {
  return api.get(`parameter/v1/province/${isocode}`);
};

const updateLocation = async (payload) => {
  try {
    const response = await api.post(
      '/api/update-location',
      null,
      payload,
      { baseURL: process.env.NEXT_PUBLIC_BASEPATH_URL },
      false,
      false
    );
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

const apiUpdateLocation = (req, res) => {
  if (req.method === 'POST') {
    const payload = req.body;

    if (!payload?.city_name) {
      return res.status(400).json({ error: 'Invalid payload' });
    }

    if (payload?.sync) {
      // if current cookies city name is match with payload
      if (req?.cookies?.city_name === payload?.city_name) {
        if (payload?.city_iso) {
          res.setHeader('Set-Cookie', [`city_iso=${payload?.city_iso}; HttpOnly; Path=/`]);
        } else {
          res.setHeader('Set-Cookie', [
            `city_iso=${DEFAULT_LOCATION.cityIsocode}; HttpOnly; Path=/`,
          ]);
        }
        return res.status(200).json({ message: 'Location set successfully', isRefresh: false });
      }

      if (payload?.city_iso) {
        res.setHeader('Set-Cookie', [
          `city_name=${payload?.city_name}; HttpOnly; Path=/`,
          `city_iso=${payload?.city_iso}; HttpOnly; Path=/`,
        ]);
      } else {
        res.setHeader('Set-Cookie', [
          `city_name=${payload?.city_name}; HttpOnly; Path=/`,
          `city_iso=${DEFAULT_LOCATION.cityIsocode}; HttpOnly; Path=/`,
        ]);
      }

      return res.status(200).json({ message: 'Location set successfully', isRefresh: true });
    }

    if (payload?.city_iso) {
      res.setHeader('Set-Cookie', [
        `city_name=${payload?.city_name}; HttpOnly; Path=/`,
        `city_iso=${payload?.city_iso}; HttpOnly; Path=/`,
      ]);
    } else {
      res.setHeader('Set-Cookie', [
        `city_name=${payload?.city_name}; HttpOnly; Path=/`,
        `city_iso=${DEFAULT_LOCATION.cityIsocode}; HttpOnly; Path=/`,
      ]);
    }

    return res.status(200).json({ message: 'Location set successfully', isRefresh: false });
  } else {
    res.setHeader('Allow', ['POST']);
    res.status(405).end(`Method ${req.method} Not Allowed`);
  }
};

export const getCityByGeolocation = ({ cityName }: { cityName: string }) => {
  return api.get(`saphybris-proxy/v1/saphybris/city-by-geolocation?cityName=${cityName}`);
};

export { getProvince, getCity, updateLocation, apiUpdateLocation };
